module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_5012.c8a898d4.png";